export default {
  data() {
    return {
      imgSrc: "https://light.vitacenter.org/photosInternes/"
    };
  }
};
